import {
  TbCreditCard,
  TbCurrencyReal,
  TbReceipt,
  TbWallet,
} from "react-icons/tb";
import { SummaryCard } from "../../../../Components/Atoms/SummaryCard";

const calcPercent = (part, total) => {
  const partNum = Number(part);
  const totalNum = Number(total);
  if (!partNum || !totalNum || totalNum <= 0) return null;
  return Math.min(100, Math.max(0, Math.round((partNum / totalNum) * 100)));
};

const SummaryCardProgress = ({
  icon: Icon,
  title,
  value,
  percent,
  footerLabel,
  loading,
  tone = "gold",
}) => (
  <div className="summary-card min-w-0 w-full">
    <div className="flex items-center gap-2">
      {Icon && (
        <div className="summary-card-icon">
          <Icon className="h-4 w-4 text-[#e7a73f]" />
        </div>
      )}
      <p className="text-xs text-gray-500">{title}</p>
    </div>
    <p className="mt-2 text-xl font-bold leading-tight text-brand-dark">
      {loading ? "Carregando…" : value || "—"}
    </p>

    {!loading && percent !== null && (
      <div className="cartoes-progress mt-3">
        <div className="cartoes-progress__track">
          <div
            className={`cartoes-progress__fill cartoes-progress__fill--${tone}`}
            style={{ width: `${percent}%` }}
          />
        </div>
        <p className="cartoes-progress__label">{percent}% do limite</p>
      </div>
    )}

    <p className="mt-2 text-xs text-gray-500">{footerLabel}</p>
  </div>
);

export const CardsSummary = ({
  cardType = "credit",
  debitBalance,
  creditLimit,
  invoiceAmount,
  availableCredit,
  creditLimitRaw,
  invoiceAmountRaw,
  availableCreditRaw,
  loading = false,
}) => {
  const display = (value) => (loading ? "Carregando…" : value || "—");
  const invoicePercent = calcPercent(invoiceAmountRaw, creditLimitRaw);
  const availablePercent = calcPercent(availableCreditRaw, creditLimitRaw);

  if (cardType === "debit") {
    return (
      <div className="dashboard-card-grid mb-5">
        <SummaryCard
          icon={TbWallet}
          title="Saldo débito"
          value={display(debitBalance)}
          footerLabel="Conta vinculada ao cartão"
        />
      </div>
    );
  }

  return (
    <div className="dashboard-card-grid mb-5">
      <SummaryCard
        icon={TbCreditCard}
        title="Limite de crédito"
        value={display(creditLimit)}
        footerLabel="Total aprovado"
      />
      <SummaryCardProgress
        icon={TbReceipt}
        title="Fatura atual"
        value={display(invoiceAmount)}
        percent={invoicePercent}
        footerLabel="Fechamento do mês"
        loading={loading}
        tone={invoicePercent !== null && invoicePercent >= 75 ? "alert" : "gold"}
      />
      <SummaryCardProgress
        icon={TbCurrencyReal}
        title="Crédito disponível"
        value={display(availableCredit)}
        percent={availablePercent}
        footerLabel="Saldo para compras"
        loading={loading}
        tone="success"
      />
    </div>
  );
};
